module.exports = __webpack_public_path__ + "img/empty.6a5fd4e6.png";